import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RecopsReadiness from "@/pages/RecopsReadiness";

export const Route = createFileRoute("/es/guia-transicion-recops")({
  head: () =>
    buildRouteHead("/es/guia-transicion-recops", {
      title:
        "Checklist de transición a RECOPS: registro de Medical Devices en España | QbD Group",
      description:
        "El 15 de junio de 2026 la AEMPS puso en marcha RECOPS y los sistemas CCPS y RPS ya no admiten nuevas comunicaciones. Completa esta checklist gratuita de autoevaluación y comprueba en menos de 5 minutos si tus Medical Devices e IVD están listos para registrarse en RECOPS sin rechazos ni bloqueos.",
    }),
  component: RecopsReadiness,
});
